










































import gql from '../gqlService.coffee'
import settings from '@/settings.coffee'
import mutations from '@/gql/mutations.coffee'
import MessagesList from '@/components/MessagesList.vue'
import ImportReportList from '@/components/ImportReportList.vue'

export default {
  "name": 'profile',
  "components": {MessagesList, ImportReportList}
  "data": ()->
    return {"export_date_begin": null, "export_date_end": null}
  "computed":
    "review_export_data_link": ()->
      return settings.review_export_data_url + "?from=#{@export_date_begin}&to=#{@export_date_end}"
    "avatar_url": ()->
      return settings.backendUrl + this.$store.state.profile.data.avatar
    "can_see_actions": ()->
      return "managers" in @$store.state.profile.groups
  "methods":
    "messageReceived": (raw_message)->
      return
    "upload_avatar": (image)->
      if not image?
        return
      self = this
      reader = new FileReader()
      reader.onload = (aImg)->
        q = mutations.gql_mutation_avatar_upload(
            self.$store.state.profile.data.uid,
            aImg.target.result,
            image.name
        )
        self.$http.post(settings.graphqlApiUrl, {"query": q}).then (res)->
          if res.ok? and res.ok
            self.$http.post(settings.authApiUrl).then (subdata)->
              if subdata.body.status == "loggedin"
                self.$store.dispatch("set_authenticated", subdata.body.profile)
      reader.readAsDataURL(image)
    "filesChanged": (arg, arg2, arg3)->
      self = this
      if arg2[0].size < 200000
        self.upload_avatar(arg2[0])
      else
        self.$store.dispatch("notify", {
          level: "danger",
          text: "Cet image est trop lourde"
        })
  "mounted": ()->
    return

}
